import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/sidebar';
import Header from '../components/Header';
import MainImages from '../components/products/MainImages';

const ImagesScreen = ({ user }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || (user && !user.isAdmin)) {
      navigate('/login');
    }
  }, [user]);

  return (
    <>
      <Sidebar />
      <main className='main-wrap'>
        <Header />
        <MainImages />
      </main>
    </>
  );
};

export default ImagesScreen;
